import type { Product } from "@/services/products";

export const allProducts: Product[] = [
  {
    id: 1,
    name: "悅聲 Pro 3",
    subtitle: "隱形耳內式智慧助聽器",
    productCode: "P000001",
    barcode: null,
    productType: "Sale",
    hasVariants: false,
    stock: null,
    stockStatus: "ok",
    variantAttributes: [],
    variants: [],
    variantCount: 0,
    productCategoryId: 1,
    price: 35800,
    salePrice: null,
    category: "耳內式",
    tags: ["隱形配戴", "AI降噪", "輕巧"],
    shortDescription: "適合追求自然外觀與日常便利的使用者，具備智慧環境辨識與清晰語音強化。",
    image: "https://readdy.ai/api/search-image?query=modern%20invisible%20in%20the%20ear%20hearing%20aid%20device%20product%20photography%20on%20soft%20cream%20white%20background%20minimalist%20professional%20lighting%20high%20quality%20close%20up%20shot&width=400&height=400&seq=1&orientation=squarish",
    galleryImages: [],
    description: "適合追求自然外觀與日常便利的使用者，具備智慧環境辨識與清晰語音強化。",
    isFeatured: true,
    isPublished: true,
    sortOrder: 10,
  },
  {
    id: 2,
    name: "富聆 Elite X",
    subtitle: "高階耳掛式智慧助聽器",
    productCode: "P000002",
    barcode: null,
    productType: "Sale",
    hasVariants: false,
    stock: null,
    stockStatus: "ok",
    variantAttributes: [],
    variants: [],
    variantCount: 0,
    productCategoryId: 2,
    price: 49800,
    salePrice: null,
    category: "耳掛式",
    tags: ["方向性麥克風", "藍牙", "App調整"],
    shortDescription: "穩定舒適的耳掛式設計，支援藍牙連線與多場景聆聽模式。",
    image: "https://readdy.ai/api/search-image?query=modern%20behind%20the%20ear%20hearing%20aid%20device%20product%20photography%20on%20soft%20cream%20white%20background%20minimalist%20professional%20lighting%20high%20quality%20close%20up%20shot&width=400&height=400&seq=2&orientation=squarish",
    galleryImages: [],
    description: "穩定舒適的耳掛式設計，支援藍牙連線與多場景聆聽模式。",
    isFeatured: true,
    isPublished: true,
    sortOrder: 20,
  },
  {
    id: 3,
    name: "充悅 Plus 5",
    subtitle: "充電式便利助聽器",
    productCode: "P000003",
    barcode: null,
    productType: "Sale",
    hasVariants: false,
    stock: null,
    stockStatus: "ok",
    variantAttributes: [],
    variants: [],
    variantCount: 0,
    productCategoryId: 3,
    price: 28800,
    salePrice: null,
    category: "充電式",
    tags: ["充電式", "長效續航", "收納盒"],
    shortDescription: "免更換電池，搭配充電收納盒，適合重視便利與穩定續航的使用者。",
    image: "https://readdy.ai/api/search-image?query=rechargeable%20hearing%20aid%20device%20with%20charging%20dock%20product%20photography%20on%20soft%20cream%20white%20background%20minimalist%20professional%20lighting%20high%20quality&width=400&height=400&seq=3&orientation=squarish",
    galleryImages: [],
    description: "免更換電池，搭配充電收納盒，適合重視便利與穩定續航的使用者。",
    isFeatured: true,
    isPublished: true,
    sortOrder: 30,
  },
  {
    id: 4,
    name: "輕風 Mini 2",
    subtitle: "迷你耳內式助聽器",
    productCode: "P000004",
    barcode: null,
    productType: "Sale",
    hasVariants: false,
    stock: null,
    stockStatus: "ok",
    variantAttributes: [],
    variants: [],
    variantCount: 0,
    productCategoryId: 1,
    price: 42800,
    salePrice: null,
    category: "耳內式",
    tags: ["迷你", "舒適", "低延遲"],
    shortDescription: "小巧貼耳、配戴穩固，降低長時間使用的不適感。",
    image: "https://readdy.ai/api/search-image?query=mini%20in%20the%20ear%20hearing%20aid%20device%20product%20photography%20on%20soft%20cream%20white%20background%20minimalist%20professional%20lighting%20high%20quality%20close%20up&width=400&height=400&seq=4&orientation=squarish",
    galleryImages: [],
    description: "小巧貼耳、配戴穩固，降低長時間使用的不適感。",
    isFeatured: true,
    isPublished: true,
    sortOrder: 40,
  },
  {
    id: 5,
    name: "聆安 Comfort",
    subtitle: "舒適入門耳掛式",
    productCode: "P000005",
    barcode: null,
    productType: "Sale",
    hasVariants: false,
    stock: null,
    stockStatus: "ok",
    variantAttributes: [],
    variants: [],
    variantCount: 0,
    productCategoryId: 2,
    price: 32800,
    salePrice: null,
    category: "耳掛式",
    tags: ["舒適", "易上手", "防潑水"],
    shortDescription: "入門族群友善的耳掛式選擇，操作直覺並兼顧日常舒適度。",
    image: "https://readdy.ai/api/search-image?query=comfortable%20behind%20the%20ear%20hearing%20aid%20device%20product%20photography%20on%20soft%20cream%20white%20background%20minimalist%20professional%20lighting%20high%20quality&width=400&height=400&seq=5&orientation=squarish",
    galleryImages: [],
    description: "入門族群友善的耳掛式選擇，操作直覺並兼顧日常舒適度。",
    isFeatured: false,
    isPublished: true,
    sortOrder: 50,
  },
  {
    id: 6,
    name: "藍聆 Link Pro",
    subtitle: "藍牙連線智慧款",
    productCode: "P000006",
    barcode: null,
    productType: "Sale",
    hasVariants: false,
    stock: null,
    stockStatus: "ok",
    variantAttributes: [],
    variants: [],
    variantCount: 0,
    productCategoryId: 4,
    price: 55800,
    salePrice: null,
    category: "藍牙式",
    tags: ["藍牙5.0", "通話串流", "App控制"],
    shortDescription: "支援手機串流與遠端調整，適合需要連線體驗的進階使用者。",
    image: "https://readdy.ai/api/search-image?query=bluetooth%20connected%20hearing%20aid%20device%20product%20photography%20on%20soft%20cream%20white%20background%20minimalist%20professional%20lighting%20high%20quality%20close%20up&width=400&height=400&seq=6&orientation=squarish",
    galleryImages: [],
    description: "支援手機串流與遠端調整，適合需要連線體驗的進階使用者。",
    isFeatured: true,
    isPublished: true,
    sortOrder: 60,
  },
];

export const productCategories = ["全部", "耳內式", "耳掛式", "充電式", "藍牙式"];
